"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.requirementWorkflowStateNameSchema = exports.requirementSeverityNameSchema = void 0;
exports.getRequirementSeverityName = getRequirementSeverityName;
exports.getRequirementWorkflowStateName = getRequirementWorkflowStateName;
exports.withStatusNames = withStatusNames;
exports.withNullableStatusNames = withNullableStatusNames;
exports.severityCountsByName = severityCountsByName;
exports.workflowStateCountsByName = workflowStateCountsByName;
exports.describeEnumValues = describeEnumValues;
const zod_1 = require("zod");
const sigma_engine_shared_1 = require("@cadstrom/sigma-engine-shared");
function enumMemberNames(enumObject) {
    const names = Object.keys(enumObject).filter((key) => Number.isNaN(Number(key)));
    return names;
}
exports.requirementSeverityNameSchema = zod_1.z.enum(enumMemberNames(sigma_engine_shared_1.RequirementsV2.RequirementSeverity));
exports.requirementWorkflowStateNameSchema = zod_1.z.enum(enumMemberNames(sigma_engine_shared_1.RequirementsV2.RequirementWorkflowState));
function getRequirementSeverityName(severity) {
    return sigma_engine_shared_1.RequirementsV2.RequirementSeverity[severity];
}
function getRequirementWorkflowStateName(workflowState) {
    return sigma_engine_shared_1.RequirementsV2.RequirementWorkflowState[workflowState];
}
function withStatusNames(row) {
    return {
        ...row,
        severityName: getRequirementSeverityName(row.severity),
        workflowStateName: getRequirementWorkflowStateName(row.workflowState),
    };
}
function withNullableStatusNames(row) {
    return {
        ...row,
        severityName: row.severity === null ? null : getRequirementSeverityName(row.severity),
        workflowStateName: row.workflowState === null ? null : getRequirementWorkflowStateName(row.workflowState),
    };
}
function severityCountsByName(counts) {
    const named = {};
    for (const [value, count] of Object.entries(counts)) {
        if (count !== undefined) {
            named[getRequirementSeverityName(sigma_engine_shared_1.RequirementsV2.RequirementSeveritySchema.parse(Number(value)))] = count;
        }
    }
    return named;
}
function workflowStateCountsByName(counts) {
    const named = {};
    for (const [value, count] of Object.entries(counts)) {
        if (count !== undefined) {
            named[getRequirementWorkflowStateName(sigma_engine_shared_1.RequirementsV2.RequirementWorkflowStateSchema.parse(Number(value)))] =
                count;
        }
    }
    return named;
}
function describeEnumValues(enumObject) {
    return Object.entries(enumObject)
        .filter((entry) => typeof entry[1] === 'number')
        .map(([name, value]) => `${value} = ${name}`)
        .join(', ');
}
//# sourceMappingURL=enum-names.js.map